import React from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";
import classNames from "classnames";

import Button from "../Button/Button";

import styles from "./ModalActions.module.scss";

const ModalActions = ({
  className,

  isYesNo,
  disabled,

  positiveText,
  negativeText,

  onClickNegative,
  onClickPositive,
}) => {
  const { t } = useSharedTranslation();

  return (
    <div className={classNames(styles["modal-actions"], "dialog-btn-wrap", className)}>
      {onClickNegative && (
        <Button
          type="button"
          color={Button.color.secondary}
          minWidth={Button.minWidth.md}
          className={classNames(styles["btn"], "dialog-btn")}
          onClick={onClickNegative}
        >
          {t(negativeText || (isYesNo ? "no" : "cancel"))}
        </Button>
      )}

      {onClickPositive && onClickNegative && <div className={styles["row-space"]}/>}

      {onClickPositive && (
        <Button
          data-focus-first={true}
          type="button"
          className={classNames(styles["btn"], "dialog-btn")}
          minWidth={Button.minWidth.md}
          onClick={onClickPositive}
          disabled={disabled}
        >
          {t(positiveText || (isYesNo ? "yes" : "ok"))}
        </Button>
      )}

    </div>
  );
};

export default ModalActions;
